// Constants
export const subir_archivos = () => {
  return {
    subir_archivos: {
      type: {
        namepath: ['afiliacion_pendientes','afiliacion_inclusiones','afiliacion_documentos'],
        description: 'type del archivo',
        readonly: true,
        type: 'text',
        datatype: 
        {
          predeterminate: ''
        }
      },
      name: {
        namepath: ['afiliacion_pendientes','afiliacion_inclusiones','afiliacion_documentos'],
        description: 'name del archivo',
        readonly: true,
        type: 'text',
        datatype: 
        {
          predeterminate: ''
        }
      }, 
      base64: {
        namepath: ['afiliacion_pendientes','afiliacion_inclusiones','afiliacion_documentos'],
        description: 'base64 del archivo',
        readonly: true,
        type: 'text',
        datatype: 
        {
          predeterminate: ''
        }
      },
    }
  }
}
